
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.783","height":"18.783"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Tracé 6772","d":"M18.14 3.244l-2.6-2.6a2.206 2.206 0 00-3.115 0L1.241 11.852a.747.747 0 00-.2.392l-1.03 5.69a.663.663 0 00.2.638.7.7 0 00.638.2l5.69-1.03a.85.85 0 00.392-.2L18.14 6.334a2.176 2.176 0 000-3.09zm-6.745.515l1.3 1.3-8 8-1.3-1.3zM1.634 17.15l.785-4.317 3.532 3.532zm5.4-1.766l-1.3-1.3 8-8 1.3 1.3zm10.08-10.08l-1.03 1.03-3.659-3.609 1.03-1.03a.711.711 0 011.03 0l2.6 2.6a.7.7 0 01.025 1.009z","fill":"#044370"}})])
          )
        }
      }
    